import request from '../index'

/**
 * GET请求
 * @param {object} params 
 * @returns 
 */
export function exampleGet(params) {
    return request({
        url: `example`,
        method: 'get',
        params
    })
}

/**
 * POST请求
 * @param {object} params 
 * @returns 
 */
export function examplePost(params) {
    return request({
        url: `example`,
        method: 'post',
        data: params
    })
}

/**
 * CSRF token获取
 * @returns 
 */
export function getCsrfToken() {
    return request({
        url: `getCsrfToken`,
        method: 'get'
    })
}

/**
 * 鉴权
 * @param {String} ticket 
 * @returns 
 */
export function auth(ticket) {
    const params = { ticket }
    return request({
        url: `auth`,
        method: 'post',
        data: params,
        // headers: {
        //     'Content-Type': 'application/x-www-fromurlencodeed'
        // }
    })
}

/**
 * 发送消息
 * @param {String} message 
 * @returns 
 */
export function sendMessage(message) {
    const params = { userInput: message }
    return request({
        url: `conversationLccp`,
        method: 'post',
        data: params
    })
}

/**
 * 联想输入
 * POST请求
 * @param {object} params 
 * @returns 
 */
 export function getAssociateSearchList(params) {
    return request({
        url: `/associateInput`,
        method: 'post',
        data: params
    })
}

/**
 * 获取物流信息
 * @param {String} message 
 * @returns 
 */
export function logisticsInfo() {
    const params = {  }
    return request({
        url: `logisticsInfo`,
        method: 'get',
        params
    })
}

/**
 * 获取历史记录
 * @param {String|Number} page 页码
 */
export function getChatHistory(page) {
    const params = { page }
    return request({
        url: `getChatHistory`,
        method: 'post',
        data: params,
    })
}

/**
 * 用户满意度调查
 */
 export function sendSatisfactionStatus(params) {
    // const params = {}
    return request({
        url: `satisfactionStatus`,
        method: 'post',
        data: params,
    })
}

/**
 * 微信jsdk配置
 * @param {String} url
 */
export function getWeixinConfigs(params) {
    return request({
        url: `getJsSdkSign`,
        method: 'get',
        params,
    })
}